import React, { useState, useEffect } from "react";
import { Box, Button as MuiButton, Typography, Card, CardContent, TextField, Grid, IconButton, Table, TableHead, TableRow, TableBody, TableCell , Dialog, DialogActions, DialogContent, DialogTitle} from "@mui/material"; 
import { useTheme } from "@mui/material";
import { tokens } from "../../theme";
import Header from "../Headers/Header";
import PersonIcon from "@mui/icons-material/Person";
import { green, red, yellow } from "@mui/material/colors";
import { styled } from "@mui/material/styles";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";  
import ArrowBackIcon from "@mui/icons-material/ArrowBack"; 
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import config from '../../Config';


const StyledCard = styled(Card)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1a1a1a" : "#fff",
  borderRadius: "16px",
  boxShadow: theme.palette.mode === "dark" ? "0 6px 15px rgba(0, 0, 0, 0.2)" : "0 10px 20px rgba(0, 0, 0, 0.1)",
  padding: "24px",
  marginBottom: "20px",
  border: `1px solid ${theme.palette.mode === "dark" ? "#333" : "#ccc"}`,
  display: "flex", 
  flexDirection: "column",
  height: "100%", 
  overflow: "hidden",
}));

const UserDetails = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const [userData, setUserData] = useState({
    marginSetting: "", 
    isActive: true,
  });
  const [walletData, setWalletData] = useState(null);
  const [portfolioData, setPortfolioData] = useState([]);
  const [selectedTab, setSelectedTab] = useState("portfolio");
  const [orderHistory, setOrderHistory] = useState([]);
  const [transactionHistory, setTransactionrHistory] = useState([]);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [brokerageAmount, setBrokerageAmount] = useState("");
  const { userId } = useParams();
  const navigate = useNavigate();

   useEffect(() => {
    const token = sessionStorage.getItem("adminToken");

    if (token && userId) {
      const apiUrl = `${config.apiBaseUrl}/admin/getUserById`;
      fetch(apiUrl, {
        method: "GET",
        headers: {
          "x-access-token": token,
          "user-id": userId,
        },
      })
        .then((response) => {
          if (response.ok) {
            return response.json();
          } else {
            throw new Error("Failed to fetch user data");
          }
        })
        .then((data) => {
          if (data && data.walletData) {
            setWalletData(data.walletData);
            setUserData({
              ...userData,
              ...data.userData, 
              marginSetting: data.userData.availableMargin || "", 
              isActive: data.userData.isActive ,
            });
            setPortfolioData(data.portfolioData || []); 
            setBrokerageAmount(data.userData.brokerageAmount || "");
          } else {
            console.error("Failed to fetch wallet data");
          }
        })
        .catch((error) => {
          console.error("Error fetching wallet data", error);
        });
    } else {
      console.error("Missing token or user-id in session");
    }
  }, [userId]);

  useEffect(() => {
    const token = sessionStorage.getItem("adminToken");
    
    if (token && userId) {
      const apiUrl = `${config.apiBaseUrl}/admin/getUserOrderHistory`;
      fetch(apiUrl, {
        method: "GET",
        headers: {
          "x-access-token": token,
          "user-id": userId,
        },
      })
        .then((response) => {
          if (response.ok) {
            return response.json();
          } else {
            throw new Error("Failed to fetch order history");
          }
        })
        .then((data) => {
          if (data && data.transactionHistory) {
            setOrderHistory(data.transactionHistory); 
          } else {
            console.error("No order history found");
          }
        })
        .catch((error) => {
          console.error("Error fetching order history", error);
        });
    } else {
      console.error("Missing token or user-id in session");
    }
  }, [userId]);

  useEffect(() => {
    const token = sessionStorage.getItem("adminToken");
    
    if (token && userId) {
      const apiUrl = `${config.apiBaseUrl}/admin/getAllTransactionHistoryByUserId`;
      fetch(apiUrl, {
        method: "GET",
        headers: {
          "x-access-token": token,
          "user-id": userId,
        },
      })
        .then((response) => {
          if (response.ok) {
            return response.json();
          } else {
            throw new Error("Failed to fetch order history");
          }
        })
        .then((data) => {
          if (data && data.transactionHistory) {
            setTransactionrHistory(data.transactionHistory); 
          } else {
            console.error("No order history found");
          }
        })
        .catch((error) => {
          console.error("Error fetching order history", error);
        });
    } else {
      console.error("Missing token or user-id in session");
    }
  }, [userId]);

  const handleSubmit = () => {
    const token = sessionStorage.getItem("adminToken");
    const marginValue = userData.marginSetting;

    if (!marginValue) {
      console.error("Margin value cannot be empty!");
      return;
    }

    if (token && userId) {
      const apiUrl = `${config.apiBaseUrl}/admin/setMarginLimit`;
      fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": token,
        },
        body: JSON.stringify({
          userId,
          margin: marginValue,
        }),
      })
        .then((response) => {
          if (response.ok) {
            return response.json();
          } else {
            throw new Error("Failed to update margin");
          }
        })
        .then((data) => {
          console.log("Margin successfully updated!");
        })
        .catch((error) => {
          console.error("Error updating margin", error);
        });
    } else {
      console.error("Missing token or user-id in session");
    }
  };

  const handleMarginChange = (e) => {
    setUserData({
      ...userData,
      marginSetting: e.target.value,
    });
  };

  const toggleUserStatus = () => {
    const token = sessionStorage.getItem("adminToken");
    if (token && userId) {
      const apiUrl = `${config.apiBaseUrl}/admin/changeUserStatus`;
      fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": token,
        },
        body: JSON.stringify({
          userId,
          status: !userData.isActive,
        }),
      })
        .then((response) => {
          if (response.ok) {
            return response.json();
          } else {
            throw new Error("Failed to change user status");
          }
        })
        .then((data) => {
          setUserData({ ...userData, isActive: !userData.isActive });
          console.log("User status updated!");
        })
        .catch((error) => {
          console.error("Error changing user status", error);
        });
    } else {
      console.error("Missing token or user-id in session");
    }
  };

  const handleConfirmDelete = () => {
      const token = sessionStorage.getItem("adminToken");
      if (token && userId) {
        const apiUrl = `${config.apiBaseUrl}/admin/deleteUserPermanent`;
        fetch(apiUrl, {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            "x-access-token": token,
            "user-id": userId,
          },
        })
          .then((response) => {
            if (response.ok) {
              navigate("/admin/users"); 
            } else {
              throw new Error("Failed to delete user");
            }
          })
        handleCloseDeleteDialog(); 
      }
    };

    const handleBrokerageChange = (e) => {
      setBrokerageAmount(e.target.value);
    };
    

    const handleBrokerageSubmit = () => {
      const token = sessionStorage.getItem("adminToken");
    
      if (!brokerageAmount) {
        console.error("Brokerage amount cannot be empty!");
        return;
      }
    
      if (token && userId) {
        const apiUrl = `${config.apiBaseUrl}/admin/setBrokerage`;
    
        fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "x-access-token": token,
          },
          body: JSON.stringify({
            userId,
            brokerageAmount: Number(brokerageAmount),
          }),
        })
          .then((response) => {
            if (!response.ok) throw new Error("Failed to update brokerage");
            return response.json();
          })
          .then(() => {
            console.log("Brokerage successfully updated!");
          })
          .catch((error) => {
            console.error("Error updating brokerage", error);
          });
      } else {
        console.error("Missing token or user-id in session");
      }
    };
    

  const handleTabChange = (tab) => {
    setSelectedTab(tab);
  };

  const handleOpenDeleteDialog = () => {
    setOpenDeleteDialog(true);
  };

  const handleCloseDeleteDialog = () => {
    setOpenDeleteDialog(false);
  };

  return (
    <Box m="20px">
      <Box display="flex" justifyContent="flex-start" mb="20px">
        <IconButton 
          onClick={() => navigate(-1)} 
          sx={{ color: theme.palette.mode === "dark" ? "white" : "black" }} 
        >
          <ArrowBackIcon />
        </IconButton>
      </Box>

      <Box display="flex" justifyContent="space-between" alignItems="center" mb="20px">
        <Header title="USER DETAILS" subtitle="Manage User Information" />
        <Box display="flex" gap="10px"> 
          <MuiButton 
            variant="contained" 
            color={userData.isActive ? "error" : "success"} 
            onClick={toggleUserStatus}
          >
            {userData.isActive ? "Disable User" : "Activate User"}
          </MuiButton>

          <MuiButton 
            variant="contained" 
            color="error" 
            onClick={handleOpenDeleteDialog} 
          >
            Permanently Delete
          </MuiButton>
        </Box>
      </Box>

      <Dialog open={openDeleteDialog} onClose={handleCloseDeleteDialog}>
        <DialogTitle>Confirm Deletion</DialogTitle>
        <DialogContent>
          Are you sure you want to permanently delete this user? This action cannot be undone.
        </DialogContent>
        <DialogActions>
          <MuiButton onClick={handleCloseDeleteDialog} color="primary">
            Cancel
          </MuiButton>
          <MuiButton onClick={handleConfirmDelete} color="error">
            Delete
          </MuiButton>
        </DialogActions>
      </Dialog>

      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <StyledCard sx={{ height: "100%" }}>
            <CardContent>
              {walletData ? (
                <Box>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={4}>
                      <Typography variant="body1" color={colors.grey[200]}>
                        <strong>Total Balance:</strong> {walletData.total_balance}
                      </Typography>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <Typography variant="body1" color={colors.grey[200]}>
                        <strong>Daily Profit:</strong> {walletData.dailyProfit}
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>
              ) : (
                <Typography variant="body1" color={colors.grey[200]} />
              )}

              <Box mt={2}>
                <TextField
                  label="Set Margin"
                  type="number"
                  value={userData.marginSetting}
                  onChange={handleMarginChange}
                  fullWidth
                  variant="outlined"
                  sx={{ marginBottom: "20px" }}
                />
                <MuiButton variant="contained" color="primary" fullWidth onClick={handleSubmit}>
                  Submit
                </MuiButton>

                <TextField
                  label="Set Brokerage (in ₹)"
                  type="number"
                  value={brokerageAmount}
                  onChange={handleBrokerageChange}
                  fullWidth
                  variant="outlined"
                  sx={{ marginBottom: "20px", marginTop:'20px' }}
                />
                <MuiButton variant="contained" color="secondary" fullWidth onClick={handleBrokerageSubmit}>
                  Submit Brokerage
                </MuiButton>
              </Box>
            </CardContent>
          </StyledCard>
        </Grid>

        <Grid item xs={12} md={6}>
          <StyledCard sx={{ height: "100%" }}>
            <CardContent>
              <Box sx={{ display: "flex", alignItems: "center", marginBottom: "16px", gap: "20px" }}>
                <Box
                  sx={{
                    width: "90px",
                    height: "90px",
                    borderRadius: "50%",
                    backgroundColor: colors.grey[300],
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    boxShadow: "0 6px 15px rgba(0, 0, 0, 0.1)",
                    marginRight: "16px",
                  }}
                >
                  <PersonIcon sx={{ fontSize: "48px", color: colors.primary[500] }} />
                </Box>

                <Box sx={{ flexGrow: 1 }}>
                  <Typography variant="h5" color={colors.grey[100]} fontWeight="bold">
                    {userData.first_name} {userData.last_name}
                  </Typography>
                  <Typography variant="body2" color={colors.grey[300]}>
                    {userData.userId}
                  </Typography>
                </Box>

                <Box>
                  {userData.isActive ? (
                    <CheckCircleIcon sx={{ color: green[500], fontSize: "30px" }} />
                  ) : (
                    <CancelIcon sx={{ color: red[500], fontSize: "30px" }} />
                  )}
                </Box>
              </Box>

              <Box sx={{ marginTop: "16px" }}>
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "12px" }}>
                  <Typography variant="body1" color={colors.grey[200]} sx={{ fontWeight: "bold" }}>
                    <strong>Email:</strong>
                  </Typography>
                  <Typography variant="body2" color={colors.grey[300]}>
                    {userData.email}
                  </Typography>
                </Box>

                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "12px" }}>
                  <Typography variant="body1" color={colors.grey[200]} sx={{ fontWeight: "bold" }}>
                    <strong>Username:</strong>
                  </Typography>
                  <Typography variant="body2" color={colors.grey[300]}>
                    {userData.user_name}
                  </Typography>
                </Box>

                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "12px" }}>
                  <Typography variant="body1" color={colors.grey[200]} sx={{ fontWeight: "bold" }}>
                    <strong>Aadhar Card:</strong>
                  </Typography>
                  <Typography variant="body2" color={colors.grey[300]}>
                    {userData.kycData?.aadharCard?.number || "N/A"}
                  </Typography>
                </Box>

                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "12px" }}>
                  <Typography variant="body1" color={colors.grey[200]} sx={{ fontWeight: "bold" }}>
                    <strong>PAN Card:</strong>
                  </Typography>
                  <Typography variant="body2" color={colors.grey[300]}>
                    {userData.kycData?.panCard?.number || "N/A"}
                  </Typography>
                </Box>

                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "12px" }}>
                  <Typography variant="body1" color={colors.grey[200]} sx={{ fontWeight: "bold" }}>
                    <strong>KYC Status:</strong>
                  </Typography>

                  <Typography 
                    variant="body2" 
                    color={userData.kycData?.kycStatus === "Approved" ? green[500] : userData.kycData?.kycStatus === "Rejected" ? red[500] : yellow[500]} 
                    sx={{ fontWeight: "bold" }}
                  >
                    {userData.kycData?.kycStatus || "Pending"}
                  </Typography>
                </Box>
              </Box>
            </CardContent>
          </StyledCard>
        </Grid>

        <Grid container spacing={3}>
          <Grid item xs={12}>
              <CardContent sx={{ position: "relative", display: "flex", flexDirection: "column", gap: 2 }}>
                 <Box 
                    display="flex" 
                    gap={2} 
                    mb={3} 
                    flexDirection={{ xs: "column", sm: "row" }} 
                    alignItems="center" 
                  >
                    <MuiButton
                      variant={selectedTab === "portfolio" ? "contained" : "outlined"}
                      color="primary"
                      onClick={() => handleTabChange("portfolio")}
                      sx={{ width: { xs: "100%", sm: "auto" } }} 
                    >
                      Portfolio Details
                    </MuiButton>
                    <MuiButton
                      variant={selectedTab === "orderHistory" ? "contained" : "outlined"}
                      color="primary"
                      onClick={() => handleTabChange("orderHistory")}
                      sx={{ width: { xs: "100%", sm: "auto" } }} 
                    >
                      Order History
                    </MuiButton>
                    <MuiButton
                      variant={selectedTab === "transactionHistory" ? "contained" : "outlined"}
                      color="primary"
                      onClick={() => handleTabChange("transactionHistory")}
                      sx={{ width: { xs: "100%", sm: "auto" } }} 
                    >
                      Transaction History
                    </MuiButton>
                  </Box>

                {selectedTab === "portfolio" && (
                  <>
                    {portfolioData && portfolioData.length > 0 ? (
                      Object.entries(
                        portfolioData.reduce((acc, instrument) => {
                          const group = acc[instrument.stockType] || [];
                          group.push(instrument);
                          acc[instrument.stockType] = group;
                          return acc;
                        }, {})
                      ).map(([stockType, group]) => (
                        <Box key={stockType} sx={{ marginBottom: 3 }}>
                          <Card sx={{ padding: 3 }}>
                            <Typography variant="h6" color={colors.grey[200]} fontWeight="bold" sx={{ marginBottom: 3 }}>
                              {stockType} Stocks
                            </Typography>

                            {group.map((instrument) => {
                              const buyTransactions = instrument.transactions.filter(transaction => transaction.transactionType === 'buy');
                              
                              const totalInvestment = buyTransactions.reduce((sum, transaction) => {
                                return sum + (transaction.quantity * transaction.price);
                              }, 0);

                              return (
                                <Grid container spacing={2} key={instrument._id} sx={{ marginBottom: 3 }}>
                                  <Grid item xs={12}>
                                    <Box sx={{
                                      display: 'flex',
                                      flexDirection: 'row',  
                                      justifyContent: 'space-between',
                                      gap: 1,
                                      padding: 2,
                                      borderRadius: 2
                                    }}>
                                      <Box sx={{ flex: 1 }}>
                                        <Typography variant="body1" color={colors.grey[200]}>
                                          <strong>Instrument:</strong> {instrument.symbol} ({instrument.stockType})
                                        </Typography>
                                        <Typography variant="body1" color={colors.grey[200]}>
                                          <strong>Quantity:</strong> {instrument.quantity}
                                        </Typography>
                                        <Typography variant="body1" color={colors.grey[200]}>
                                          <strong>Avg. Price:</strong> {instrument.avgPrice.toFixed(2)}
                                        </Typography>
                                        <Typography variant="body1" color={colors.grey[200]}>
                                          <strong>Trade Type:</strong> {instrument.tradeType}
                                        </Typography>
                                      </Box>
                                      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                                        <Typography variant="body1" color={colors.grey[200]}>
                                          <strong>Total Investment :</strong> ₹{totalInvestment.toFixed(2)}
                                        </Typography>
                                      </Box>
                                    </Box>
                                  </Grid>
                                  <Grid item xs={12}>
                                    <Box sx={{
                                      border: `1px solid ${colors.grey[600]}`, 
                                      borderRadius: 2,
                                      padding: 2,
                                      overflowX: 'auto',  
                                    }}>
                                      <Table sx={{
                                        minWidth: 650, 
                                        tableLayout: 'fixed', 
                                        overflowX: 'auto',  
                                      }} size="small">
                                        <TableHead>
                                          <TableRow>
                                            <TableCell sx={{ color: colors.grey[200], fontWeight: 'bold' }}>Order ID</TableCell>
                                            <TableCell sx={{ color: colors.grey[200], fontWeight: 'bold' }}>Status</TableCell>
                                            <TableCell sx={{ color: colors.grey[200], fontWeight: 'bold' }}>Transaction Type</TableCell>
                                            <TableCell sx={{ color: colors.grey[200], fontWeight: 'bold' }}>Quantity</TableCell>
                                            <TableCell sx={{ color: colors.grey[200], fontWeight: 'bold' }}>Price</TableCell>
                                            <TableCell sx={{ color: colors.grey[200], fontWeight: 'bold' }}>Created At</TableCell>
                                          </TableRow>
                                        </TableHead>
                                        <TableBody>
                                          {instrument.transactions.map((transaction) => (
                                            <TableRow key={transaction.orderId}>
                                              <TableCell sx={{ color: colors.grey[200], whiteSpace: 'normal', wordWrap: 'break-word' }}>
                                                {transaction.orderId}
                                              </TableCell>
                                              <TableCell sx={{ color: colors.grey[200], whiteSpace: 'normal', wordWrap: 'break-word' }}>
                                                {transaction.status}
                                              </TableCell>
                                              <TableCell sx={{ color: colors.grey[200], whiteSpace: 'normal', wordWrap: 'break-word' }}>
                                                {transaction.transactionType}
                                              </TableCell>
                                              <TableCell sx={{ color: colors.grey[200], whiteSpace: 'normal', wordWrap: 'break-word' }}>
                                                {transaction.quantity}
                                              </TableCell>
                                              <TableCell sx={{ color: colors.grey[200], whiteSpace: 'normal', wordWrap: 'break-word' }}>
                                                {transaction.price}
                                              </TableCell>
                                              <TableCell sx={{ color: colors.grey[200], whiteSpace: 'normal', wordWrap: 'break-word' }}>
                                                {new Date(transaction.createdAt).toLocaleString('en-GB', {
                                                  year: 'numeric',
                                                  month: 'short',
                                                  day: 'numeric',
                                                  hour: '2-digit',
                                                  minute: '2-digit',
                                                  second: '2-digit',
                                                  hour12: true, 
                                                })}
                                              </TableCell>
                                            </TableRow>
                                          ))}
                                        </TableBody>
                                      </Table>
                                    </Box>
                                  </Grid>
                                </Grid>
                              );
                            })}
                          </Card>
                        </Box>
                      ))
                    ) : (
                        <Typography variant="body1" color={colors.grey[200]}>
                          No portfolio data available.
                        </Typography>
                      )}
                    </>
                 )}

                 {selectedTab === "orderHistory" && (
                  <Card>
                    <CardContent>
                      <Typography variant="h6">Order History</Typography>
                      <Box sx={{ overflowX: 'auto' }}> 
                        <Table>
                          <TableHead>
                            <TableRow>
                              <TableCell>Order ID</TableCell>
                              <TableCell>Symbol</TableCell>
                              <TableCell>Transaction Type</TableCell>
                              <TableCell>Order Type</TableCell>
                              <TableCell>Trade Type</TableCell>
                              <TableCell>Quantity</TableCell>
                              <TableCell>Price</TableCell>
                              <TableCell>Status</TableCell>
                              <TableCell >Created At</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {orderHistory.length === 0 ? (
                              <TableRow>
                                <TableCell colSpan={8} align="center">No data available</TableCell> 
                              </TableRow>
                            ) : (
                              orderHistory.map((order) => (
                                <TableRow key={order._id}>
                                  <TableCell>{order.orderId}</TableCell>
                                  <TableCell>{order.symbol}</TableCell>
                                  <TableCell>{order.transactionType}</TableCell>
                                  <TableCell>{order.orderType}</TableCell>
                                  <TableCell>{order.tradeType}</TableCell>
                                  <TableCell>{order.quantity}</TableCell>
                                  <TableCell>{order.price}</TableCell>
                                  <TableCell>{order.status}</TableCell>
                                  <TableCell sx={{ color: colors.grey[200], whiteSpace: 'normal', wordWrap: 'break-word' }}>
                                    {new Date(order.createdAt).toLocaleString('en-GB', {
                                    year: 'numeric',
                                    month: 'short',
                                    day: 'numeric',
                                    hour: '2-digit',
                                    minute: '2-digit',
                                    second: '2-digit',
                                    hour12: true, 
                                    })}
                                  </TableCell>
                                </TableRow>
                              ))
                            )}
                          </TableBody>
                        </Table>
                      </Box>
                    </CardContent>
                  </Card>
                )}

                {selectedTab === "transactionHistory" && (
                  <Card>
                    <CardContent>
                      <Typography variant="h6">Transaction History</Typography>
                      <Box sx={{ overflowX: 'auto' }}> 
                        <Table>
                          <TableHead>
                            <TableRow>
                              <TableCell>Transaction Id</TableCell>
                              <TableCell>Type</TableCell>
                              <TableCell>Transaction Type</TableCell>
                              <TableCell>Amount</TableCell>
                              <TableCell>Status</TableCell>
                              <TableCell >Created At</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {transactionHistory.length === 0 ? (
                              <TableRow>
                                <TableCell colSpan={5} align="center">No data available</TableCell>
                              </TableRow>
                            ) : (
                              transactionHistory.map((transaction) => (
                                <TableRow key={transaction._id}>
                                  <TableCell>{transaction.transactionId}</TableCell>
                                  <TableCell>{transaction.type}</TableCell>
                                  <TableCell>{transaction.transactionType}</TableCell>
                                  <TableCell>{parseFloat(transaction.amount).toFixed(2)}</TableCell>
                                  <TableCell>{transaction.status}</TableCell>
                                  <TableCell sx={{ color: colors.grey[200], whiteSpace: 'normal', wordWrap: 'break-word' }}>
                                    {new Date(transaction.createdAt).toLocaleString('en-GB', {
                                    year: 'numeric',
                                    month: 'short',
                                    day: 'numeric',
                                    hour: '2-digit',
                                    minute: '2-digit',
                                    second: '2-digit',
                                    hour12: true, 
                                    })}
                                  </TableCell>
                                </TableRow>
                              ))
                            )}
                          </TableBody>
                        </Table>
                      </Box>
                    </CardContent>
                  </Card>
                )}
              </CardContent>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default UserDetails;